import styled from "styled-components";
import { ThemeType } from "../../../types/Theme";

export const ModalTermosUsoWrapper = styled.div<{ theme: ThemeType }>`
  position: relative;
  width: 100%;
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: 2.4rem;
  padding: 4rem 4rem;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 3rem;
`;

export const HeaderTermosContainer = styled.div<{ theme: ThemeType }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1.5rem;
  text-align: center;
  width: 100%;

  .titulo {
    font-family: "Inter", sans-serif;
    font-weight: 400;
    font-size: 16px;
    color: ${({ theme }) => theme.colors.tertiary};
    line-height: 1.2;

    @media (max-width: 768px) {
      font-size: 14px;
    }
  }

  .subtitulo {
    font-family: "Inter", sans-serif;
    font-weight: 700;
    font-size: 20px;
    color: ${({ theme }) => theme.colors.primary};
    line-height: 1.2;

    @media (max-width: 768px) {
      font-size: 18px;
    }
  }
`;

export const ResumoGrid = styled.div<{ theme: ThemeType }>`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  width: 100%;

  .grid-bloco {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    grid-template-rows: repeat(2, minmax(0, 1fr));
    width: 100%;

    &.duas-colunas {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }

    .cel {
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;
      padding: 1.5rem 1rem;
      border: 1px solid ${({ theme }) => theme.colors.tertiary};
      font-family: "Inter", sans-serif;
      font-size: 14px;
      color: ${({ theme }) => theme.colors.tertiary};
      line-height: 1.2;
      word-break: break-word;

      @media (max-width: 768px) {
        font-size: 12px;
        padding: 1.2rem 0.8rem;
      }
    }

    .cel.header {
      background-color: ${({ theme }) => theme.colors.background2};
      font-weight: 700;
    }

    .cel.dado {
      background-color: ${({ theme }) => theme.colors.white};
      font-weight: 400;
    }

    .cel.tl {
      border-top-left-radius: 2rem;
    }
    .cel.tr {
      border-top-right-radius: 2rem;
    }
    .cel.bl {
      border-bottom-left-radius: 2rem;
    }
    .cel.br {
      border-bottom-right-radius: 2rem;
    }
  }
`;

export const CupomContainer = styled.div<{ theme: ThemeType }>`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;

  p {
    font-family: "Inter", sans-serif;
    font-size: 14px;
    color: ${({ theme }) => theme.colors.tertiary};
    line-height: 1.4;
    margin: 0;
    text-align: left;
    width: 100%;

    @media (max-width: 768px) {
      font-size: 12px;
    }
    .titulo {
        font-weight: bold;
    }
    .label {
      font-weight: 700;
    }
    .texto {
      font-weight: 400;
    }
  }
`;

export const ModalTermosUsoContainer = styled.div<{ theme: ThemeType }>`
  width: 100%;

  .termosUso {
    background-color: ${({ theme }) =>
      theme.mode === "dark" ? theme.colors.background2 : "#f9f9f9"};
    border-top-left-radius: 2rem;
    border-top-right-radius: 2rem;
    padding: 2rem 2rem 0 2rem;
    display: flex;
    flex-direction: column;
    gap: 1.5rem;

    .titulo-termos {
      font-family: "Inter", sans-serif;
      font-weight: 700;
      font-size: 16px;
      color: ${({ theme }) => theme.colors.tertiary};
      line-height: 1.2;
      text-align: left;
      width: 100%;

      @media (max-width: 768px) {
        font-size: 14px;
      }
    }

    .texto {
      max-height: 28rem;
      padding-right: 1rem;
      font-family: "Inter", sans-serif;
      font-weight: 400;
      font-size: 14px;
      color: ${({ theme }) => theme.colors.tertiary};
      line-height: 1.5;
      text-align: justify;

      @media (max-width: 768px) {
        font-size: 12px;
      }

      p {
        margin: 0 0 1rem 0;
      }
    }
  }
`;

export const RodapeTermos = styled.div<{ theme: ThemeType }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 2rem;
  width: 100%;
  flex-wrap: wrap;

  .concordar {
    display: flex;
    align-items: center;
    gap: 1rem;
    cursor: pointer;

    .textoConcordo {
      font-family: "Inter", sans-serif;
      font-weight: 400;
      font-size: 16px;
      color: ${({ theme }) => theme.colors.primary};
      line-height: 1;

      @media (max-width: 768px) {
        font-size: 14px;
      }
    }
  }
`;
